<script setup lang="ts">
import { computed } from "vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface SVGWrapperIconProps {
  viewBox: string;
  className?: string;
  size: iconSize;

  background?: colorTag;
}

const props = withDefaults(defineProps<SVGWrapperIconProps>(), {
  className: "",
  background: "transparent",
  size: "md",
});

const backgroundClass = computed((): string => `bg-${props.background}`);
const sizeClass = computed((): string => `icon-${props.size}`);
</script>

<template>
  <svg
    :class="{
      [className]: className.length > 0,
      [backgroundClass]: background !== undefined,
      [sizeClass]: true,
    }"
    :viewBox="viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <slot />
  </svg>
</template>

<style lang="scss">
$sizes: (
  xxs: $base-icon-size * 0.3,
  xs: $base-icon-size * 0.6,
  sm: $base-icon-size * 0.75,
  md: $base-icon-size * 1,
  lg: $base-icon-size * 1.2,
  xl: $base-icon-size * 1.5,
  xxl: $base-icon-size * 2,
);

@each $size, $val in $sizes {
  .icon-#{$size} {
    height: $val;
    width: $val;
  }

  .icon-#{$size}-important {
    height: $val !important;
    width: $val !important;
  }
}
</style>
